import React, {Fragment, useCallback, useEffect, useState} from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import {searchProductFromAPI} from '../../Helper/Helper';
import _ from 'lodash';

export default function AsyncItemSearch({onItemSelect, width, language, axiosConfig, onFocus, disabled, extraParams}) {
	const [open, setOpen] = useState(false);
	const [items, setItems] = useState([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (!open) {
			setItems([]);
		}
	}, [open]);

	const extraParamsRef = React.useRef(extraParams);
	useEffect(() => {
		extraParamsRef.current = extraParams;
	}, [extraParams]);

	const onChangeSearch = (props) => {
		setLoading(true);
		searchProductFromAPI(props, axiosConfig, ({type, value}) => {
			switch (type) {
				case 'Result': {
					setItems(value);
					break;
				}
				default:
					break;
			}
			setLoading(false);
		}, extraParamsRef.current || {});
	}

	const onOptionSelect = (option, value) => {
		return option.product_code == value.product_code;
	}

	const changeTextThrottle = useCallback(_.debounce(onChangeSearch, 300), []);

	return (
		<Autocomplete
			disabled={disabled}
			id="async-item-search"
			style={{width: width}}
			open={open}
			onOpen={() => {
				setOpen(true);
			}}
			onClose={() => {
				setOpen(false);
			}}
			getOptionSelected={(option, value) => onOptionSelect(option, value)}
			getOptionLabel={(option) => `${option.product_code} - ` + option.product_name}
			options={items}
			loading={loading}
			autoHighlight={true}
			onChange={(e, v, r) => onItemSelect && v && onItemSelect(v)}
			noOptionsText={language.no_data}
			renderInput={(params) => (
				<TextField
					{...params}
					label={language.search_item}
					variant="outlined"
					onFocus={e => onFocus && onFocus(e)}
					InputProps={{
						...params.InputProps,
						endAdornment: (
							<Fragment>
								{loading ? <CircularProgress color="inherit" size={20}/> : null}
								{params.InputProps.endAdornment}
							</Fragment>
						)
					}}
					autoFocus={true}
					onChange={e => changeTextThrottle(e.target.value)}
				/>
			)}
		/>
	);
}
